<template>
    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding">
                    <!-- Heading -->
                    <div class="w-lg-65 text-center mx-lg-auto mb-7">
                        <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Header" tag-name="h3" :init="EditorConfig" />
                    </div>
                    <!-- End Heading -->
                    <!-- Table -->
                    <div class="w-lg-65 mx-lg-auto">
                        <div class="table-responsive-sm">
                            <table class="table table-lg table-borderless">

                                <tbody>

                                    <template v-for="(drow, drowIndex) in NotaryRows">

                                        <tr :style="RowStyle(drowIndex, true)">
                                            <th scope="row" class="h6" v-html="NotaryRows[drowIndex].Desc">
                                            </th>
                                            <td style="font-weight:bold" v-for="(x, dcolIndex) in BlockProps.Cols" class="" v-html="NotaryRows[drowIndex].Vals[dcolIndex]">
                                            </td>
                                        </tr>
                                    </template>

                                    <template v-for="(drow, drowIndex) in BlockProps.Rows">

                                        <tr :style="RowStyle(drowIndex)">
                                            <th scope="row" class="h6">
                                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Rows[drowIndex].Desc" tag-name="span" :init="EditorConfig" />
                                            </th>
                                            <td v-for="(x, dcolIndex) in BlockProps.Cols" class="">
                                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" tag-name="span" keyDown v-model="BlockProps.Rows[drowIndex].Vals[dcolIndex]" :init="EditorConfig"></omnieditor>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                        <!-- End Table -->
                        <div class="row">
                            <div class="col-md-12">
                                <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Footer" :init="EditorConfig" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                        <div class="row">
                            <div class="col col-12">
                                <label for="customRange2" class="form-label">Number of Additional Rows</label>
                                <div class="input-group mb-3">
                                    <button @click="RemoveRow" class="btn btn-outline-secondary" type="button">-</button>
                                    <input readonly style="text-align:center;" min="1" max="6" type="number" class="form-control" v-model="NumRowsUI">
                                    <button @click="AddRow" class="btn btn-outline-secondary" type="button">+</button>
                                </div>
                                <div class="progress" style="height: 20px;">
                                    <div class="progress-bar" role="progressbar" :style="{'width': NumRowsUIFilled}" :aria-valuenow="NumRowsUIFilled" aria-valuemin="0" :aria-valuemax="MaxRows"></div>
                                </div>
                            </div>
                            <hr style="margin-top: 10px; margin-bottom:5px;" />
                        </div>

                        <propertycoloreditor :propertyname="'RowColor'" :blockprops="BlockProps" :prompt="'Row Background Color'"></propertycoloreditor>
                        <propertycoloreditor :propertyname="'RowColorAlt'" :blockprops="BlockProps" :prompt="'Alternating Row Background Color'"></propertycoloreditor>


                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'


    export default {
        inheritAttrs: false,
        name: 'MobileNotaryFeeSchedule.vue',
        mixins: [ContentBlockBase],
        props: ['notaryconfig'],
        components: {
        },
        computed:
        {
            NotaryConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.notaryconfig) {
                    return this.notaryconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigMobileNotary) {
                    return this.Store.TenantConfig.serviceConfigMobileNotary;
                } 
             
            },
            RowStyle() {
                return function (index, notaryRow) {

                    var realIndex = notaryRow? index : this.NotaryRows.length + index;
                    if (realIndex % 2 === 0) {
                        // Even row index
                        return { backgroundColor: this.BlockProps.RowColorAlt };
                    } else {
                        // Odd row index
                        return { backgroundColor: this.BlockProps.RowColor };
                    }
                };
            },
            NumRowsUIFilled() {
                return `${Math.floor(this.NumRowsUI / this.MaxRows * 100)}%`;
            },
            NumColsUIFilled() {
                return `${Math.floor(this.NumColsUI / this.MaxCols * 100)}%`;
            },
            TotalRows() {
                var tot = this.NotaryRows.length + this.BlockProps.Rows.legnth;
                return tot;
            }
        },
        data() {
            return {  
                MaxRows: 10,
                NumRowsUI: 0,
                MaxCols: 1,
                NumColsUI: 1,
                NotaryRows: [],
                AdditionalCfg: 'https://admin.notarylaunchpad.com/home/sitesettings#NotarySettings'
            };
        },
        watch: {
            NumRowsUI: function (newVal, oldVal) {

                while (newVal < this.BlockProps.Rows.length) {
                    this.BlockProps.Rows.pop();
                }

                while (newVal > this.BlockProps.Rows.length) {
                    var newRow = JSON.stringify(this.Store.DefaultBlockProps[this.ComponentType].Rows[0]);
                    newRow = JSON.parse(newRow);

                    this.BlockProps.Rows.push(newRow);
                }
            },
            NumColsUI: function (newVal, oldVal) {
                while (newVal < this.BlockProps.Cols.length) {
                    // Remove excess columns from Cols
                    this.BlockProps.Cols.pop();

                    // Remove corresponding elements from Vals in each Row
                    this.BlockProps.Rows.forEach(row => {
                        row.Vals.pop();
                    });
                }

                while (newVal > this.BlockProps.Cols.length) {
                    // Add new columns to Cols
                    var newCol = JSON.stringify(this.Store.DefaultBlockProps[this.ComponentType].Cols[0]);
                    newCol = JSON.parse(newCol);
                    this.BlockProps.Cols.push(newCol);

                    // Add corresponding elements to Vals in each Row
                    this.BlockProps.Rows.forEach(row => {
                        var newVal = JSON.stringify(this.Store.DefaultBlockProps[this.ComponentType].Rows[0].Vals[0]);
                        newVal = JSON.parse(newVal);
                        row.Vals.push(newVal);
                    });
                }
            }

        },
        methods:
        {
            AddRow: function () {
                this.NumRowsUI = Math.min(this.NumRowsUI + 1, this.MaxRows);
            },
            RemoveRow: function () {
                this.NumRowsUI = Math.max(this.NumRowsUI - 1, 0);
            },
            AddCol: function () {
                this.NumColsUI = Math.min(this.NumColsUI + 1, this.MaxCols);
            },
            RemoveCol: function () {
                this.NumColsUI = Math.max(this.NumColsUI - 1, 1);
            },
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },            
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            this.NotaryRows = [];
            if (this.NotaryConfig.travelCostBaseFee) {
                this.NotaryRows.push(
                    {
                        Desc: 'Base Trip Fee',
                        Vals: [`$${Number.parseFloat(this.NotaryConfig.travelCostBaseFee).toFixed(2)}`]
                    },
                );
            }

            if (this.NotaryConfig.travelCostPerMile) {
                this.NotaryRows.push(
                    {
                        Desc: `Per Mile Fee`,
                        Vals: [`$${Number.parseFloat(this.NotaryConfig.travelCostPerMile).toFixed(2)}`]
                    },
                );
            }

            if (this.NotaryConfig.offerLoanClosings) {
                var loanFeeDesc = `In-Person Loan Signings`;
                this.NotaryRows.push(
                    {
                        Desc: loanFeeDesc,
                        Vals: [`$${Number.parseFloat(this.NotaryConfig.notaryLoanClosingCost).toFixed(2)}`]
                    },
                );
            }

        },
        beforeUnmount()
        {
            
        },
        mounted() {
            this.NumRowsUI = this.BlockProps.Rows.length;
            nextTick().then(() => {
      
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    
</style>

